import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'searchInfoCS'})
export class SearchInfoCSPipe implements PipeTransform {
    transform(arr: any[], txt: string): any {
        const res = arr.filter(item => {
            if (!txt) txt = ""
            let str = JSON.stringify(item)
            const idx = str.indexOf(txt)
            return (idx !== -1)
        })
        return res
    }
}
